/* eslint-disable */

import React, { forwardRef, useImperativeHandle, useRef, useState, useEffect } from "react";
import "./customFloatingFilterForOpenEnrollment.css";
import SearchIcon from "@material-ui/icons/Search";

export default forwardRef((props, ref) => {
	const inputRef = useRef(null);
	useImperativeHandle(ref, () => {
		return {
			onParentModelChanged(parentModel) {
				inputRef.current.value = parentModel;
			}
		};
	});

	const onInputBoxChanged = (input) => {
		const value = input.target.value;
		inputRef.current.value = value;

		props.parentFilterInstance((instance) => {
			if (props.column.colDef.field !== "employees") {
				// only set filter immediately for non-employees
				instance?.componentInstance?.myMethodForTakingValueFromFloatingFilter(value);
				instance?.componentInstance?.handleSearch(); // triggers local filter
			}
		});
	};

	const triggerSearch = () => {
		props.parentFilterInstance((instance) => {
			const value = inputRef.current?.value || "";

			// Always update the filter value
			instance?.componentInstance?.myMethodForTakingValueFromFloatingFilter(value);

			// But only trigger search API if it's the employees column
			if (props.column.colDef.field === "employees") {
				instance?.componentInstance?.handleSearch();
			}
		});
	};

	const handleHitEnter = (event) => {
		if (event.key === "Enter") {
			triggerSearch();
		}
	};

	const handleSearchButtonClick = () => {
		triggerSearch();
	};

	const style = {
		color: props.color
	};

	return (
		<div className="inputWithSearchFilter">
			<input
				ref={inputRef}
				className="customFloatingFilterForOpenEnrollment"
				style={style}
				type="text"
				onInput={onInputBoxChanged}
				onKeyDown={handleHitEnter}
			/>
			<button onClick={handleSearchButtonClick} className="searchButton">
				<span>
					<SearchIcon style={{ fontSize: "18px" }} />
				</span>
			</button>
		</div>
	);
});
